export const fiscalPersonTypes = [
  { label: "Física", value: "NATURAL_PERSON" },
  { label: "Moral", value: "JURIDICAL_PERSON" }
]
